import React from 'react';
import { Link } from 'react-router-dom';

const Team = () => {
  return (
    <main>
      <section className="team section" style={{paddingTop: '8rem', background: 'white', padding: '8rem 0 6rem 0'}}>
        <div className="container" style={{maxWidth: '1200px', margin: '0 auto', padding: '0 1rem', width: '100%', boxSizing: 'border-box'}}>
          <div className="section-title" style={{textAlign: 'center', marginBottom: '4rem'}}>
            <h1 style={{
              fontSize: 'clamp(2.5rem, 5vw, 4rem)', 
              fontWeight: 800, 
              marginBottom: '2rem', 
              color: '#AA5B52'
            }}>Our Team</h1>
            <p style={{
              fontSize: 'clamp(1.1rem, 3vw, 1.4rem)', 
              color: '#666', 
              lineHeight: 1.6,
              maxWidth: '800px',
              margin: '0 auto',
              padding: '0 1rem'
            }}>We bring together expertise in artificial intelligence, healthcare, and legal advocacy to transform diagnostic accuracy.</p>
          </div>
          
          <div className="team-grid" style={{
            display: 'grid', 
            gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', 
            gap: '3rem', 
            maxWidth: '1000px', 
            margin: '0 auto',
            padding: '0 1rem'
          }}>
            <div className="team-card" style={{
              background: 'linear-gradient(135deg, #f7e6e1 0%, #fff 100%)',
              borderRadius: '2rem',
              padding: '2.5rem',
              textAlign: 'center',
              boxShadow: '0 8px 25px rgba(170,91,82,0.08)',
              border: '1px solid #f0f0f0'
            }}>
              <div className="team-avatar" style={{ 
                backgroundImage: 'url(/images/andrew.jpg)', 
                backgroundSize: 'cover', 
                backgroundPosition: 'center',
                width: '120px',
                height: '120px',
                borderRadius: '50%',
                margin: '0 auto 2rem auto',
                border: '4px solid white',
                boxShadow: '0 8px 20px rgba(170,91,82,0.2)'
              }}></div>
              <h3 className="team-name" style={{
                fontSize: 'clamp(1.3rem, 3vw, 1.8rem)',
                fontWeight: 700,
                color: '#AA5B52',
                marginBottom: '0.5rem'
              }}>Andrew Gregory</h3>
              <p className="team-role" style={{
                fontSize: 'clamp(1rem, 2.5vw, 1.2rem)',
                color: '#f57c00',
                fontWeight: 600,
                marginBottom: '1.5rem'
              }}>Chief Executive Officer</p>
              <p style={{
                fontSize: 'clamp(0.95rem, 2.5vw, 1.1rem)',
                color: '#555',
                lineHeight: 1.6,
                textAlign: 'left'
              }}>Andrew Gregory is driven by a relentless commitment to prevent the tragedies that stem from missed or delayed diagnoses. With a proven record as a founder and a background in advanced AI and healthcare, he brings a rare blend of technical vision and human empathy. Andrew leads Afterimage with the conviction that every patient deserves answers—and that technology, when guided by compassion, can save lives and restore trust in medicine.</p>
            </div>
            
            <div className="team-card" style={{
              background: 'linear-gradient(135deg, #e8f4f8 0%, #fff 100%)',
              borderRadius: '2rem',
              padding: '2.5rem',
              textAlign: 'center',
              boxShadow: '0 8px 25px rgba(45,91,123,0.08)',
              border: '1px solid #f0f0f0'
            }}>
              <div className="team-avatar" style={{ 
                backgroundImage: 'url(/images/peter.jpg)', 
                backgroundSize: 'cover', 
                backgroundPosition: 'center',
                width: '120px',
                height: '120px',
                borderRadius: '50%',
                margin: '0 auto 2rem auto',
                border: '4px solid white',
                boxShadow: '0 8px 20px rgba(45,91,123,0.2)'
              }}></div>
              <h3 className="team-name" style={{
                fontSize: 'clamp(1.3rem, 3vw, 1.8rem)',
                fontWeight: 700,
                color: '#2D5B7B',
                marginBottom: '0.5rem'
              }}>Peter Anderson, JD</h3>
              <p className="team-role" style={{
                fontSize: 'clamp(1rem, 2.5vw, 1.2rem)',
                color: '#f57c00',
                fontWeight: 600,
                marginBottom: '1.5rem'
              }}>Chief Legal Officer</p>
              <p style={{
                fontSize: 'clamp(0.95rem, 2.5vw, 1.1rem)',
                color: '#555',
                lineHeight: 1.6,
                textAlign: 'left'
              }}>Raised in a family of medical professionals, Peter Anderson has dedicated his career to standing up for patients and families failed by the healthcare system. As a nationally recognized medical malpractice attorney, he has championed both justice and reform—securing life-changing outcomes for clients while forging partnerships with providers to drive systemic improvement. Peter's leadership at Afterimage ensures that accountability and healing go hand in hand, inspiring others to join a mission that puts people first.</p>
            </div>
          </div>
          
          <div style={{
            marginTop: '5rem', 
            textAlign: 'center',
            background: 'linear-gradient(135deg, #AA5B52 0%, #8B4A42 100%)',
            borderRadius: '2rem',
            padding: '3rem 2rem',
            color: 'white'
          }}>
            <h2 style={{
              fontSize: 'clamp(2rem, 4vw, 2.5rem)',
              fontWeight: 700,
              marginBottom: '1.5rem',
              color: 'white'
            }}>Join Our Mission</h2>
            <p style={{
              maxWidth: '700px', 
              margin: '0 auto 2.5rem auto',
              fontSize: 'clamp(1rem, 2.5vw, 1.2rem)',
              lineHeight: 1.6,
              color: 'rgba(255,255,255,0.9)',
              padding: '0 1rem'
            }}>We're building a team of passionate individuals who share our vision for transforming healthcare through improved diagnostic accuracy.</p>
            <Link to="/contact" className="btn btn-secondary" style={{
              background: 'white',
              color: '#AA5B52',
              padding: 'clamp(1rem, 2.5vw, 1.2rem) clamp(1.5rem, 4vw, 2.5rem)',
              borderRadius: '3rem',
              textDecoration: 'none',
              fontWeight: 700,
              fontSize: 'clamp(1rem, 2.5vw, 1.1rem)',
              boxShadow: '0 4px 15px rgba(0,0,0,0.1)',
              transition: 'transform 0.2s ease'
            }}>Get In Touch</Link>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Team; 